import { AnalyticsComponent } from "@/constants/analytics/Analytics";

const TabSources = {
  Explore: `Explore ${AnalyticsComponent.Tab}`,
  Home: `Home ${AnalyticsComponent.Tab}`,
  Messages: `Messages ${AnalyticsComponent.Tab}`,
  Profile: `Profile ${AnalyticsComponent.Tab}`,
  Schedule: `Schedule ${AnalyticsComponent.Tab}`,
} as const;

const TabPressedEvents = {
  Explore: `${TabSources.Explore} pressed`,
  Home: `${TabSources.Home} pressed`,
  Messages: `${TabSources.Messages} pressed`,
  Profile: `${TabSources.Profile} pressed`,
  Schedule: `${TabSources.Schedule} pressed`,
} as const;

const UserTabSelector = "User Tab Selector";

const UserTabSelectorAnalytics = {
  Pressed: `${UserTabSelector} pressed`,
} as const;

type TabSource = ValueOf<typeof TabSources>;
export type { TabSource };
export { TabPressedEvents, TabSources, UserTabSelectorAnalytics };
